'use client'

import dayjs from 'dayjs'

import { Star } from '../../icons'
import { Link } from '../Link'
import { ReadMore } from '../ReadMore'
import { Typography } from '../Typography'
import { Container, IconContainer, Item } from './styles'

export interface ReviewListProps {
  reviews: {
    id: number
    age: string
    comment?: string
    postAt: string
    programName: string
    score: number
    sex: string
  }[]
  moreLink?: {
    href: string
    external?: boolean
    target?: string
  }
}

export const ReviewList = ({ reviews, moreLink }: ReviewListProps) => {
  return (
    <>
      <Container>
        {reviews.map((review) => (
          <Item key={review.id}>
            <div className="flex items-center justify-between">
              <Typography variant="headline3" color="gray.01">
                {review.programName}
              </Typography>

              <div className="ml-2 flex items-center">
                <IconContainer>
                  <Star />
                </IconContainer>
                <Typography variant="body2" className="ml-1">
                  {review.score.toFixed(1)}
                </Typography>
              </div>
            </div>

            <Typography variant="body2" color="gray.02">
              {review.age} / {review.sex}
            </Typography>

            {review.comment && (
              <div className="mt-2 flex flex-col">
                <ReadMore truncateLines={3}>
                  <Typography variant="body1" as="p">
                    {review.comment}
                  </Typography>
                </ReadMore>
              </div>
            )}

            <Typography
              variant="body2"
              color="gray.02"
              className={
                review.comment
                  ? '-z-10 -mt-6 select-none'
                  : '-z-10 mt-2 select-none'
              }
            >
              {dayjs(review.postAt).format('YYYY年MM月DD日')}
            </Typography>
          </Item>
        ))}
      </Container>
      {moreLink && (
        <div className="mt-4 flex justify-end">
          <Link variant="secondary" {...moreLink}>
            レビューをもっと見る
          </Link>
        </div>
      )}
    </>
  )
}
